<template>
  <div
    v-loading.fullscreen.lock="isSubmitting"
    :element-loading-text="$t('Submitting...')"
    class="company-form-page page-content">
    <el-row class="page-header -with-back-button" type="flex" justify="space-between">
      <el-col :span="24">
        <h2 class="page-title" v-if="isUpdated">แก้ไขรายละเอียด</h2>
        <h2 class="page-title" v-else>เพิ่มบริษัทใหม่</h2>
      </el-col>
    </el-row>

    <el-form
      :model="companyForm"
      :rules="companyFormRules"
      ref="companyForm"
      label-width="120px"
      label-position="top"
      @submit.native.prevent="submitForm('companyForm')"
      :disabled="isSubmitting"
      class="company-form company-detail-info">
      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">รายละเอียดบริษัท</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="ชื่อบริษัท" prop="name">
                <el-input
                  v-model="companyForm.name"
                  id="companyForm.name"
                  :maxlength="50"
                  placeholder="กรอกชื่อบริษัท"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="10" :offset="1">
              <el-form-item label="Bill payment card name" prop="name_on_payment_card">
                <el-input
                  v-model="companyForm.name_on_payment_card"
                  id="companyForm.name_on_payment_card"
                  placeholder="กรอกชื่อบริษัท"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="เลขประจำตัวผู้เสียภาษี" prop="tax_id">
                <el-input
                  v-model="companyForm.tax_id"
                  id="companyForm.tax_id"
                  @change="updateMaskTaxId"
                  ref="companyForm.tax_id"
                  @input.native="handleInput($event, 'companyForm.tax_id', 'taxIdMask')"
                  placeholder="กรอกเลขประจำตัวผู้เสียภาษี"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="ชื่อเว็ปไซต์สำหรับจัดการของบริษัท" prop="slug">
                  <el-input
                    :value="`${baseHost}/`"
                    :readonly="true"
                    class="slug-base-host"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" class="company-slug-holder">
              <el-input
                v-model="companyForm.slug"
                :disabled="isUpdated"
                id="companyForm.slug"
                class="company-slug-input"
                @keyup.native="genSlug(vm)"
                placeholder="กรอกชื่อเว็ปไซต์สำหรับจัดการของบริษัท"></el-input>
            </el-col>
          </el-row>
          <el-row v-if="!isUpdated">
            <el-col :span="20" class="slug-preview-block">
              <h4>ตัวอย่างรูปแบบที่จะนำไปใช้งาน:</h4>
              <code>{{ baseHost }}/<span>{{ slugPreview }}</span></code>
              <el-button
                v-if="slugPreview !== 'company-web-name' && slugPreview !== '' && slugPreview !== companyForm.slug"
                type="primary"
                size="mini"
                @click="assignSlug">เลือกใช้ชื่อนี้</el-button>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row class="logo-uploader-holder">
            <el-col :span="24">
              <el-form-item label="โลโก้บริษัท" prop="logo">
                <div class="logo-holder" v-if="companyForm.logo">
                  <img :src="companyForm.logo" class="logo"/>
                </div>
                <el-upload
                  class="company-logo-uploader"
                  :action="uploadUrl"
                  drag
                  :show-file-list="false"
                  :http-request="handleHttpRequest"
                  :on-success="handleLogoSuccess"
                  :on-error="handleLogoFail"
                  :before-upload="beforeLogoUpload">
                  <div class="upload-instruction" v-loading="isUploading">
                    <h3>อัพโหลดโลโก้บริษัท</h3>
                    <i class="el-icon-upload logo-uploader-icon"></i>
                  </div>
                </el-upload>
                <div class="upload-instruction-hint">
                  ขนาดขั้นต่ำ 500px x 500px และต้องเป็นไฟล์นามสกุล JPG, PNG, GIF
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section last">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ที่อยู่หลักของบริษัท</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="ที่อยู่" prop="address.line_1">
                <el-input
                  v-model="companyForm.address.line_1"
                  id="companyForm.address.line_1"
                  placeholder="กรอกที่อยู่"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="ตำบล/แขวง" prop="address.district">
                <el-input
                  v-model="companyForm.address.district"
                  id="companyForm.address.district"
                  placeholder="กรอกตำบล/แขวง"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item label="อำเภอ/เขต" prop="address.city">
                <el-input
                  v-model="companyForm.address.city"
                  id="companyForm.address.city"
                  placeholder="กรอกอำเภอ/เขต"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="จังหวัด" prop="address.province">
                <el-select
                  v-model="companyForm.address.province"
                  id="companyForm.address.province">
                  <el-option
                    v-for="province in provinceList"
                    :key="province"
                    :label="province"
                    :value="province">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item label="รหัสไปรษณีย์" prop="address.postal_code">
                <el-input
                  v-model="companyForm.address.postal_code"
                  id="companyForm.address.postal_code"
                  @change="updatePostCode"
                  ref="companyForm.address.postal_code"
                  @input.native="handleInput($event, 'companyForm.address.postal_code', 'postcode')"
                  placeholder="กรอกรหัสไปรษณีย์"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="โทรศัพท์" prop="address.tel">
                <el-input
                  v-model="companyForm.address.tel"
                  id="companyForm.address.tel"
                  placeholder="กรอกโทรศัพท์"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item label="โทรสาร" prop="address.fax">
                <el-input
                  v-model="companyForm.address.fax"
                  id="companyForm.address.fax"
                  placeholder="กรอกโทรสาร"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="21">
              <el-form-item class="button-bar">
                <el-button
                  type="primary"
                  plain
                  class="cancel-btn"
                  @click="goBack"
                  id="companyForm.cancelButton">{{ 'Cancel' | translate }}</el-button>
                <div class="submit-button-group">
                  <el-button
                    type="danger"
                    class="terminate-btn"
                    icon="el-icon-delete"
                    v-if="isUpdated"
                    @click="confirmTerminate"
                    id="companyForm.terminateButton">{{ 'Terminate' | translate }}</el-button>
                  <el-button
                    type="primary"
                    id="companyForm.submitButton"
                    icon="el-icon-edit"
                    native-type="submit">{{ 'Save and continue' | translate }}</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint no-param-reassign: 0 */
import _ from 'lodash';
import helpers from '@/libs/helpers';
import str from '@/libs/string';
import { createMask } from 'imask';
// import XRegExp from 'xregexp';

/**
 * Company Form view
 */
const CompanyFormView = {
  name: 'company-form',
  props: ['companyId'],
  data() {
    return {
      isSubmitting: false,
      isUploading: false,
      isSetupUpdateData: false,
      companyFormRules: {
        name: [
          { required: true, max: 50, message: 'กรุณากรอกชื่อบริษัท', trigger: 'blur' },
        ],
        /* name_on_payment_card: [
          { required: true, message: 'กรุณากรอกชื่อบริษัท', trigger: 'blur' },
        ], */
        tax_id: [
          { required: true, validator: this.checkTaxID, message: 'กรุณากรอกเลขประจำตัวผู้เสียภาษี 10 หรือ 13 หลัก', trigger: 'blur' },
          /* { type: 'number', message: 'กรุณากรอกหมายเลขประจำตัวบริษัทเป็นตัวเลขเท่านั้น'
          , trigger: 'blur' }, */
        ],
        /* logo: [
          { required: true, message: 'กรุณาเลือกโลโก้บริษัท', trigger: 'blur' },
        ], */
        slug: [
          { required: true, message: 'กรุณากรอกชื่อเว็ปในการจัดการข้อมูลบริษัท', trigger: 'blur' },
          { validator: this.checkSlug, message: 'กรุณากรอกชื่อเว็ปในการจัดการข้อมูลบริษัทให้อยู่ในรูปแบบที่ถูกต้อง (ชื่อเว็ปประกอบด้วยตัวอักษรภาษาอังกฤษ "a-z", เลข "0-9" หรือ เครื่องหมายขีด "-" เท่านั้น)', trigger: 'blur' },
        ],
        'address.line_1': [
          { required: true, message: 'กรุณากรอกที่อยู่บริษัท', trigger: 'blur' },
        ],
        'address.district': [
          { required: true, message: 'กรุณากรอกตำบล/แขวง', trigger: 'blur' },
        ],
        'address.city': [
          { required: true, message: 'กรุณากรอกอำเภอ/เขต', trigger: 'blur' },
        ],
        'address.province': [
          { required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'blur' },
        ],
        'address.postal_code': [
          { required: true, min: 5, message: 'กรุณากรอกรหัสไปรษณีย์', trigger: 'blur' },
          /* { type: 'number', message: 'กรุณากรอกรหัสไปรษณีย์เป็นตัวเลขเท่านั้น',
          trigger: 'blur' }, */
        ],
        'address.tel': [
          { required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' },
          // { type: 'string',
          // pattern: new XRegExp('^02-\\d{3}-\\d{4}$|^0[3-5|7]\\d{1}-\\d{3}-\\d{3}$|^0[6|8|9]
          // \\d{1}-\\d{3}-\\d{4}$', 'g'),
          // message: 'กรุณากรอกหมายเลขโทรศัพท์ให้ตรงรูปแบบ', trigger: 'blur' },
        ],
        'address.fax': [
          { message: 'กรุณากรอกหมายเลขโทรสาร', trigger: 'blur' },
          // { type: 'string',
          // pattern: new XRegExp('^02-\\d{3}-\\d{4}$|^0[3-5|7]\\d{1}-\\d{3}-\\d{3}$', 'g'),
          // message: 'กรุณากรอกหมายเลขโทรสารให้ตรงรูปแบบ', trigger: 'blur' },
        ],
      },
      slugPreview: 'company-web-name',
      companyForm: {
        id: null,
        tax_id: '',
        slug: '',
        name: '',
        // name_on_payment_card: '',
        logo: '',
        address: {
          line_1: '',
          district: '',
          city: '',
          province: '',
          postal_code: '',
          tel: '',
          fax: '',
        },
        profiles_count: 0,
      },
      mask: {
        taxIdMask: [
          { mask: '0000000000' },
          { mask: '0000000000000' },
        ],
        postcode: {
          mask: '00000',
        },
        telMask: [
          { mask: '{02}-000-0000' },
          { mask: '{0}00-000-0000' },
          { mask: '{0}00-000-000' },
        ],
        faxMask: [
          { mask: '{02}-000-0000' },
          { mask: '{0}00-000-000' },
        ],
      },
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.idToken;
    },
    company() {
      return this.$store.getters.currentCompany;
    },
    isUpdated() {
      return typeof this.companyId !== 'undefined';
    },
    uploadUrl() {
      return `${process.env.CLOUDINARY_API_BASE_URL}${window.appConfig.CLOUDINARY_CLOUD_NAME}/upload`;
    },
    provinceList() {
      return helpers.getProvinceList();
    },
    baseHost() {
      return helpers.getCurrentBaseHost();
      // return window.appConfig.BASE_HOST;
    },
    vm() {
      return this;
    },
  },
  methods: {
    goBack() {
      if (this.isUpdated) {
        this.$router.push({
          name: 'CompanyDetail',
          params: {
            companyId: this.companyId,
          },
        });
      } else {
        this.$router.push({ name: 'CompanyList' });
      }
    },
    handleLogoSuccess(res) {
      this.isUploading = false;
      if (res.secure_url) {
        this.companyForm.logo = res.secure_url;
      }
    },
    handleLogoFail(res) {
      this.isUploading = false;
      let errorMessage = this.$t('Unexpected error');
      if (res) {
        errorMessage = res;
        if (res.error) {
          errorMessage = res.error;
          if (res.error.message) {
            errorMessage = res.error.message;
          }
        }
      }
      this.$store.dispatch('ADD_ERROR_FLASH', errorMessage);
    },
    beforeLogoUpload(file) {
      const isImage = ['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) !== -1;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('Logo picture must be JPG, PNG or GIF format!');
      }
      if (!isLt2M) {
        this.$message.error('Logo picture size can not exceed 2MB!');
      }
      return isImage && isLt2M;
    },
    handleHttpRequest(options) {
      this.isUploading = true;
      return this.$store.dispatch('UPLOAD_COMPANY_LOGO', options.file);
    },
    confirmTerminate() {
      this.$confirm('ท่านกำลังจะลบบริษัทนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', this.$t('Warning'), {
        confirmButtonText: this.$t('Confirm'),
        confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning',
      }).then(() => {
        this.isSubmitting = true;
        this.$store.dispatch('DELETE_COMPANY_INFO', this.companyId).then(() => {
          this.isSubmitting = false;
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ลบข้อมูลบริษัทสำเร็จแล้ว',
          });
          this.$nextTick(() => {
            this.$router.push({ name: 'CompanyList' });
          });
        }).catch((msg) => {
          this.isSubmitting = false;
          if (msg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
      }).catch(() => {
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm(valid) {
      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      const action = this.isUpdated ? 'UPDATE_COMPANY_INFO' : 'CREATE_COMPANY_INFO';
      const payload = this.companyForm;
      // transform payload
      this.$store.dispatch(action, payload).then(() => {
        this.isSubmitting = false;
        let successMessage = 'สร้างบริษัทสำเร็จแล้ว';
        if (this.isUpdated) {
          successMessage = 'แก้ไขข้อมูลบริษัทสำเร็จแล้ว';
        }
        this.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: successMessage,
        });
        this.$nextTick(() => {
          this.goBack();
        });
      }).catch((msg) => {
        this.isSubmitting = false;
        if (msg) {
          this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
        } else {
          this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
        }
      });
      return true;
    },
    setSlugPreview(slug) {
      this.slugPreview = slug;
    },
    genSlug: _.debounce((vm) => {
      let slug = str.str_slug(vm.companyForm.slug);
      if (slug === '') {
        slug = 'company-web-name';
      }
      vm.setSlugPreview(slug);
    }, 150),
    checkTaxID(rule, value, cb) {
      let len = 0;
      if (value) {
        len = value.toString().length;
      }
      if (len !== 10 && len !== 13) {
        cb(new Error('Tax ID must be 10 or 13 digits'));
      }
      cb();
    },
    checkSlug(rule, value, cb) {
      if (this.companyForm.slug !== this.slugPreview || ['scb'].indexOf(this.slugPreview) !== -1) {
        cb(new Error('mismatch slug'));
      } else {
        cb();
      }
    },
    assignSlug() {
      if (this.slugPreview !== 'company-web-name') {
        this.companyForm.slug = this.slugPreview;
        this.$refs.companyForm.validateField('slug');
      }
    },
    clearUpdateData() {
      this.isSetupUpdateData = false;
      this.companyForm.id = null;
      this.companyForm.tax_id = '';
      this.companyForm.slug = '';
      this.companyForm.name = '';
      // this.companyForm.name_on_payment_card = '';
      this.companyForm.logo = '';
      this.companyForm.address.tel = '';
      this.companyForm.address.fax = '';
      this.companyForm.address.line_1 = '';
      this.companyForm.address.district = '';
      this.companyForm.address.city = '';
      this.companyForm.address.province = '';
      this.companyForm.address.postal_code = '';
      this.companyForm.profiles_count = 0;
    },
    updateMaskTaxId() {
      this.maskValue(this.companyForm, 'tax_id', {
        mask: this.mask.taxIdMask,
      });
    },
    /* updateMaskTel() {
      this.maskValue(this.companyForm.address, 'tel', {
        mask: this.mask.telMask,
      });
    },
    updateMaskFax() {
      this.maskValue(this.companyForm.address, 'fax', {
        mask: this.mask.faxMask,
      });
    }, */
    updatePostCode() {
      try {
        this.maskValue(this.companyForm.address, 'postal_code', this.mask.postcode);
      } catch (e) {
        console.error(e);
      }
    },
    maskValue(form, field, maskOptions) {
      const mask = createMask(maskOptions);
      const val = form[field];
      if (val) {
        const resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue(form, field, maskOptions) {
      const mask = createMask(maskOptions);
      const val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },
    setupUpdateData() {
      this.isSetupUpdateData = true;
      Object.keys(this.company).forEach((key) => {
        if (key === 'address') {
          Object.keys(this.company.address).forEach((addrKey) => {
            this.$set(this.companyForm.address, addrKey, this.company.address[addrKey]);
          });
        } else {
          this.$set(this.companyForm, key, this.company[key]);
        }
      });
      this.slugPreview = this.company.slug;
      this.updateMaskTaxId();
      this.updatePostCode();
    },
    /* eslint prefer-arrow-callback: 0 */
    handleInput: _.debounce(function handleInputFn(evt, refName, maskName) {
      helpers.handleInput(evt,
        this.$refs, refName,
        this.mask, maskName);
    }, process.env.HANDLE_INPUT_DEBOUNCE_INTERVAL, { tailing: true }),
  },
  mounted() {
    // load data to form
    if (this.isUpdated) {
      setTimeout(() => {
        if (typeof this.company === 'undefined' || this.company === null) {
          this.goBack();
        }
      }, 1000);
    }
    this.$nextTick(() => {
      if (this.isUpdated && this.company) {
        this.setupUpdateData();
      }
    });
  },
  watch: {
    company(newVal) {
      if (this.isUpdated && !this.isSetupUpdateData && newVal) {
        this.setupUpdateData();
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId));
  },
  beforeRouteLeave(to, from, next) {
    this.clearUpdateData();
    this.$store.dispatch('SELECT_CURRENT_COMPANY', '');
    next();
  },
};
export default CompanyFormView;
</script>

<style lang="scss">
  @import '../../assets/styles/color';
  .company-form {
    .el-select {
      width: 100%;
    }
    .company-slug-holder {
      padding-top: 30px;
    }
    .company-slug-input {

    }
    .slug-base-host {
      padding-left: 5px;

      input {
        font-family: monospace;
        border: 0;
        background: transparent;
        font-size: 18px;
        text-align: right;
      }
    }
    .cancel-btn, .terminate-btn {
      padding-top: 16px;
      padding-bottom: 16px;
    }
    .submit-button-group {
      float: right;
    }
    .slug-preview-block {
      line-height: 1;
      // margin-top: 20px;
      border: 1px solid $color-primary-purple;
      background: lighten($color-secondary-purple, 40%);
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 20px;

      h4 {
        margin: 0 0 5px;
      }
      code {
        span {
          font-weight: bold;
          font-size: 16px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/company/company-form.vue